const getOr = require('lodash/fp/getOr');

function parsePosition(position, index) {
  const p = path => getOr(null, path, position);
  return {
    security: {
      id: p('psPosId'),
      name: p('psDesc'),
      title: p('psAstName'),
      number: p('psSecNmb') || p('psActNo'),
      description: p('psDesc'),
    },
    index: position.index,
    id: `${p('psPosId')}-${p('psCcy')}-${p('psRicCode ')}`
      .replace(/\./g, '-'),
    isin: p('psIsin'),
    currency: p('psCcy'),
    quantity: p('psQty'),
    marketValue: p('psMktValueRefCcy') || p('psMktValRefCcy'),
    unrealisedGL: p('psUnrGinLosRefCcy'),
    unrealisedGLPercent: p('psUnrGinLosPerc'),
    averagePurchasePrice: p('psPurPrc'),
    lastPrice: p('psMktPrc'),
    priceDate: p(['ratesHistory', 'psMktPrcDte']) || p('psMktPrcDt'),
    dayChange: p(['ratesHistory', 'psDayChg']),
    dayChangePercentage: p(['ratesHistory', 'pSDayChgPct']),
    unrealisedGLPositionCurrency: p('psUnrGinLosPosCcy'),
    proportion: p('psActPct'),
    ricCode: p('psRicCode'),
    asOfDate: p('asOfDate'),
    restricted:p('restrictedInd') || null,
    enabled:p('enabledInd') || null,
    tradable:p('tradableInd') || null,
  };
}

module.exports = parsePosition;
